export const formatNumber = (n: number): string => {
  if (n < 1e3) return n + ''
  if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(1) + 'K'
  if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(1) + 'M'
  if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(1) + 'B'
  if (n >= 1e12) return +(n / 1e12).toFixed(1) + 'T'

  return ''
}

export const formatTime = (seconds: number): string => {
  seconds = seconds < 0 ? 0 : seconds
  const s = Math.floor(seconds % 60)
  const m = Math.floor((seconds / 60) % 60)
  const h = Math.floor(seconds / (60 * 60))

  if (isNaN(seconds) || seconds === Infinity) {
    return '--:--'
  }

  return (
    (h > 0 ? `${h}:` : '') +
    (m > 9 ? `${m}:` : `0${m}:`) +
    (s > 9 ? s : `0${s}`)
  )
}

export const formatTimer = (seconds: number, format: 'ms' | 's'): string => {
  const s = Math.floor(seconds % 60)
  const m = Math.floor((seconds < 0 ? -seconds : seconds) / 60)

  if (isNaN(seconds) || seconds === Infinity) {
    return '0'
  }

  if (format === 'ms') {
    return (
      ((m > 9 && `${m}:`) || (m > 0 && `0${m}:`) || '00:') +
      (s > 9 ? s : `0${s}`)
    )
  } else {
    return m * 60 + s + ''
  }
}

export const getTimeFromString = (timer: string): number => {
  if (!timer) return 0

  let time = 0

  try {
    const [minutes, seconds] = timer.split(':')

    time = +seconds + +minutes * 60
  } catch (e) {
    console.warn(e), 'default time 0'
  }

  return time
}

export function getContrastColour(color: string): '#000' | '#FFF' {
  const isLightColor = (c: string) => {
    const rgbList = colorToRgb(c)

    if (!rgbList) {
      return false
    }

    const [r, g, b] = rgbList

    const o = Math.round((+r * 299 + +g * 587 + +b * 114) / 1000)

    return o > 125
  }

  function colorToRgb(col: string) {
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(col)) {
      let c = col.substring(1).split('')

      if (c.length === 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]]
      }
      const s: number = +('0x' + c.join(''))

      // tslint:disable-next-line: no-bitwise
      return [(s >> 16) & 255, (s >> 8) & 255, s & 255]
    }
    const cl = col.match(
      /rgba?\((\d{1,3}), ?(\d{1,3}), ?(\d{1,3})\)?(?:, ?(\d(?:\.\d?))\))?/,
    )

    return cl?.[1] && cl?.[2] && cl?.[3] ? [cl[1], cl[2], cl[3]] : [0, 0, 0]
  }

  return isLightColor(color) ? '#000' : '#FFF'
}

export function getSVGRatio(svgText: string): number {
  const regex = /<svg.*viewBox="([0-9 ]+)".*>/gm
  const m = regex.exec(svgText)

  const viewbox = m?.[1].split(' ')
  const width = viewbox?.[2] || 0
  const height = viewbox?.[3] || 0

  if (!m) return 0

  if (m && m.index === regex.lastIndex) {
    regex.lastIndex++
  }

  return +height ? +width / +height : 0
}
